import doc                    from 'decorators/doc';
import model                  from 'decorators/model';
import { Timestampable }      from 'helpers/traits';
import { Blamable }           from 'helpers/traits';
import { computed }           from 'mobx';
import InvoicePrivateApiModel from 'modelx/models/abstracts/InvoicePrivateApiModel';

export type BillableStatusReference = InvoiceBillableStatusReference;

@model.cacheDuration()
@model.staticLabel('BillableStatus')
@model.urnResource('billable_status')
@doc.path('/billable_statuses/{?id}')
export default class BillableStatusModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'label': string;
		'reference': InvoiceBillableStatusReference;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
		'reference': string;
	}> = {};

	@doc.string declare label: string;
	@doc.number declare position: number;
	@doc.string declare reference: InvoiceBillableStatusReference;

	@computed
	public get color() {
		switch (this.reference) {
			case 'in_creation':
				return '#e67e22';
			case 'to_validate':
				return '#E62260';
			case 'validated':
				return '#484AEC';
			case 'created':
				return '#3498db';
			case 'to_bill':
				return '#9b59b6';
			case 'billed':
				return '#2ecc71';
			case 'cancelled':
				return '#aaa';
			default: 
				return 'blue';
		}
	}
}

